import { composeRenderProps, Button as RACButton, ButtonProps as RACButtonProps } from 'react-aria-components'
import { tv, VariantProps } from 'tailwind-variants'
import { focusRing } from './utils'

export interface ButtonProps extends RACButtonProps {
  variant?: VariantProps<typeof button>['variant']
}

const button = tv({
  extend: focusRing,
  base: 'px-5 py-2 text-sm text-center transition rounded border border-black/10 dark:border-white/10 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.1)] dark:shadow-none cursor-pointer',
  variants: {
    variant: {
      primary: 'bg-baf-yellow hover:bg-baf-yellow-600 pressed:bg-baf-yellow-800 text-black',
      secondary:
        'bg-gray-100 hover:bg-gray-200 pressed:bg-gray-300 text-gray-800 dark:bg-zinc-600 dark:hover:bg-zinc-500 dark:pressed:bg-zinc-400 dark:text-zinc-100',
      destructive: 'bg-red-700 hover:bg-red-800 pressed:bg-red-900 text-white',
      icon: 'border-0 p-1 flex items-center justify-center text-gray-600 hover:bg-black/[5%] pressed:bg-black/10 dark:text-zinc-400 dark:hover:bg-white/10 dark:pressed:bg-white/20 disabled:bg-transparent',
      card: 'rounded-[3px] shadow-[0_2px_3px_rgba(0,0,0,0.3)] bg-white hover:bg-gray-200 pressed:bg-gray-300',
      small: 'flex flex-nowrap items-center gap-1 px-2 py-1',
      toolbelt:
        'bg-baf-yellow hover:bg-baf-yellow-600 pressed:bg-baf-yellow-800 text-black flex flex-col items-center uppercase text-xs gap-1 p-1 w-full',
    },
    isDisabled: {
      true: 'bg-gray-100 dark:bg-zinc-800 text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText] border-black/5 dark:border-white/5',
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
  compoundVariants: [{ isDisabled: true, variant: 'toolbelt', class: 'opacity-50 text-zinc-600 bg-baf-yellow' }],
})

export function Button(props: ButtonProps) {
  return (
    <RACButton
      {...props}
      className={composeRenderProps(props.className, (className, renderProps) =>
        button({ ...renderProps, variant: props.variant, className })
      )}
    />
  )
}
